module.exports = __webpack_public_path__ + "img/cta_bg.30d96334.svg";